import Companies from '../../api/companies'
import DefaultAvatar from '@/assets/avatar-default.png'
import DefaultCover from '@/assets/header-default.png'
import DefaultCoverIcon from '@/assets/cover-picture-icon.png'

export default {
  namespaced: true,
  state: {
    company: null
  },
  getters: {
    company: state => {
      return state.company
    },
    brandPictureUrl: (state, getters) => {
      return getters.imageUrlForCompany(state.company)
    },
    imageUrlForCompany: state => company => {
      if (company && company.imageUrl) {
        return company.imageUrl
      } else if (company && (company.id || company.companyId)) {
        return `/api/identicons/${company.id || company.companyId}`
      } else {
        return DefaultAvatar
      }
    },
    coverImageForCompany: state => company => {
      if (company) {
        return company.coverImageUrl || DefaultCover
      } else {
        return DefaultCover
      }
    },
    coverImageUrl: (state, getters) => {
      return getters.coverImageForCompany(state.company)
    },
    coverPictureIconUrl: state => {
      if (state.company) {
        return state.company.coverPictureThumbnailUrl || DefaultCoverIcon
      } else {
        return DefaultCoverIcon
      }
    }
  },
  mutations: {
    setCompany (state, company) {
      state.company = company
    }
  },
  actions: {
    async getCompanyDetail ({commit}, companyId) {
      try {
        const company = await Companies.getDetail(companyId)
        commit('setCompany', company[0])
      } catch (err) {}
    },
    async getSocialProfiles ({commit}, companyId) {
      try {
        const profiles = await Companies.getSocialProfiles(companyId)
        commit('users/setProfiles', profiles, { root: true })
      } catch (err) {}
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hirer-profile.js